import React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ButtonComponent from "../buttons/ButtonComponent";
import PropTypes from "prop-types";

export default function DialogComponent({title, buttons, onAccept, open, onClose, children}) {

    return <Dialog
        sx={{zIndex: 1399}}
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {title}
        </DialogTitle>
        <DialogContent>
            {children}
        </DialogContent>
        <DialogActions>
            {buttons.accept && <ButtonComponent onClick={onAccept || (() => {})}>{buttons.accept}</ButtonComponent>}
            <ButtonComponent onClick={onClose || (() => {})}>{buttons.cancel}</ButtonComponent>
        </DialogActions>
    </Dialog>
}

DialogComponent.propTypes = {
    title: PropTypes.string,
    buttons: PropTypes.object,
    onAccept: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func,
}